import React from "react";

import { cn } from "@/utils/tailwind.ts";

type SvInputProps = React.HTMLAttributes<HTMLInputElement> & {
  value: string;
  disabled?: boolean;
};

export const SvInput = ({
  className,
  disabled,
  value,
  // eslint-disable-next-line react/prop-types
  onChange,
  ...props
}: SvInputProps) => {
  return (
    <input
      className={cn(
        "border-ind-grey-600 rounded-sm border-1 px-4 py-2 overflow-ellipsis",
        className,
      )}
      value={value}
      onChange={onChange}
      disabled={disabled}
      {...props}
    />
  );
};
